// RadioSlider.jsx
import React, { useState } from "react";
import "./radio-slider.css";
const RadioSlider = ({
  options = ["Option 1", "Option 2", "Option 3"],
  value = 0,
  onChange
}) => {
  // const [selectedIndex, setSelectedIndex] = useState(defaultIndex);

  return (
    <div className="radio-slider-container">
      <div className="radio-options">
        {options.map((option, index) => (
          <div key={index} className="radio-option">
            <input
              type="radio"
              id={`radio-${index}`}
              name="radio-group"
              value={option}
              checked={index === value}
              onChange={() => onChange(index)}
              className="radio-input"
            />
            <label htmlFor={`radio-${index}`} className="radio-label">
              {option}
            </label>
          </div>
        ))}
      </div>
      <div
        className="highlight-block"
        style={{
          left: `${(value / options.length) * 100}%`,
          width: `${100 / options.length}%`
        }}
      />
    </div>
  );
};

export default RadioSlider;
